import styled from "styled-components";

export const WalkDiv = styled.div`
width: 80%;
height:90vh;
display:flex;
justify-content: center;
align-items:center;
margin:0 auto;margin-top:-120px;
margin-bottom:100px;
}}
`;
